import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9c02678"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-6",
  align: "center"
}
const _hoisted_2 = { align: "center" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex mt-4" }
const _hoisted_5 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_6 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_7 = {
  style: {"font-size":"small"},
  "justify-start": ""
}
const _hoisted_8 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_9 = {
  style: {"font-size":"small"},
  "justify-start": ""
}
const _hoisted_10 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_11 = {
  style: {"font-size":"small"},
  "justify-start": ""
}
const _hoisted_12 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_13 = {
  style: {"font-size":"small"},
  "justify-start": ""
}

import { useI18n } from "vue-i18n"
import { computed, onBeforeUnmount, ref } from "vue"
import { DoctorProfile, RequestResponse } from "@/types"
import HeaderComponent from "../Header/HeaderComponent.vue"
import router from "@/router"
import { onMounted } from "vue"
import { useRoute } from "vue-router"
import { useUserActions } from "@/stores/user-actions"
import StudentComment from "./StudentComments/StudentComment.vue"
import FooterComponent from "../Footer/FooterComponent.vue"
import SubscribeComponent from "./Subscribe/SubscribeComponent.vue"
import { useToast } from "vue-toast-notification"
import { useMeta } from "vue-meta"


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorPage',
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const id = ref()
const userAction = useUserActions()
const isLoading = ref(true)
const doctor = ref<DoctorProfile | undefined>(undefined)
const responseStatus = ref({})
const smallWindow = ref(window.innerWidth < 1000)
const $toast = useToast()
onMounted(() => {
  id.value = route.params.id
  localStorage.removeItem("docId")
  getDoctorProfile()
  window.addEventListener("resize", updateWindowSize)
})

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
})

const openDocLocation = (): void => {
  const address = doctor?.value?.clinicStreet.split(" ")

  window.open(
    `https://www.google.com/maps/search/${address?.[0] ?? ""}+${
      address?.[1] ?? ""
    }+${doctor?.value?.clinicLocation ?? ""}+${doctor?.value?.clinicLand}`,
    "_blank"
  )
}

const toDoctorLink = (): void => {
  const headerLink = doctor?.value?.linkedInLink.split(":", 1)
  const wwwLink = doctor?.value?.linkedInLink.split(".", 1)
  console.log(headerLink)
  if (headerLink?.[0] == "https") {
    window.open(doctor?.value?.linkedInLink, "_blank")
  } else if (wwwLink?.[0] == "www") {
    window.open("https://" + doctor?.value?.linkedInLink, "_blank")
  }
}

// const buildTimeArray = (totalTime: string[]) => {
//   let firstDate = new Date(totalTime[0])

//   totalTime.slice(1, -1).forEach((date, index) => {
//     availableDatesArray.value = [firstDate]

//     const thisDate = new Date(date)
//     const nextDate = new Date(totalTime[index + 2])

//     const differenceInDays = Math.abs(
//       (nextDate.getTime() - thisDate.getTime()) / (1000 * 3600 * 24)
//     )

//     if (differenceInDays > 1) {
//       availableDatesArray.value.push(thisDate)

//       twoDimensionalDateArray.value.push(availableDatesArray.value)

//       availableDatesArray.value = []
//       firstDate = nextDate
//     } else if (index == totalTime.length - 3) {
//       availableDatesArray.value.push(nextDate)

//       twoDimensionalDateArray.value.push(availableDatesArray.value)
//     }
//   })
//   modelDateArray.value = twoDimensionalDateArray.value
// }

const doctorName = computed(() => {
  return doctor.value
    ? `${doctor.value.title} ${doctor.value.firstName} ${
        doctor.value.lastName || ""
      }`
    : ""
})
const doctorSpecialty = computed(() => {
  return doctor.value?.specialty ?? ""
})

const doctorAddress = computed(() => {
  return `${doctor.value?.clinicStreet}, ${doctor.value?.clinicLocation}, ${doctor.value?.clinicLand}`
})

useMeta(
  computed(() => ({
    title: `${doctorName.value ?? ""} 
        ${doctor.value?.clinicLocation ?? "Medcircle"}
        ${doctorSpecialty.value ?? ""}`,
    description: `${t("meta.doctor-description")} ${doctorName.value} - ${
      doctorSpecialty.value
    } `,

    meta: [
      { name: "viewport", content: "user-scalable=no" },
      {
        property: "og:title",
        content:
          doctorName.value +
          " " +
          doctor.value?.clinicLocation +
          " " +
          doctorSpecialty.value,
      },
      { property: "og:image", content: doctor?.value?.photo },
      {
        property: "og:type",
        content: `website`,
      },
      {
        property: "og:description",
        content: `${t("meta.doctor-description")} ${doctorName.value} - ${
          doctorSpecialty.value
        } `,
      },
      {
        property: "og:url",
        content: `https://medcircle.eu/doctors/${id.value}`,
      },
      {
        property: "og:site_name",
        content: `medcircle`,
      },
    ],
  }))
)

const getDoctorProfile = async (): Promise<void> => {
  const response = await userAction.getSingleDoctor(id.value, {})
  responseStatus.value = response
  if (response.success) {
    doctor.value = response.result as DoctorProfile
  }
  isLoading.value = false
}

const apply = (): void => {
  localStorage.setItem("docId", id.value)
  router.push(`${id.value}/application`)
}

const subscribed = (event: any) => {
  responseStatus.value = event.val

  if (event.val.success) {
    if (event.subscribed) {
      $toast.success(t("subscribe-successful"), {
        position: "top-right",
      })
    }
  } else {
    $toast.error(t("subscribe-not-successful"), {
      position: "top-right",
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createVNode(_component_request_status, {
      class: "mt-6",
      response: responseStatus.value,
      isLoading: isLoading.value
    }, null, 8, ["response", "isLoading"]),
    (!isLoading.value && doctor.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_row, { class: "mt-5" }, {
            default: _withCtx(() => [
              (!smallWindow.value)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "3"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { "max-width": "700" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "mt-2",
                        justify: "space-between"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "mt-1",
                            cols: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "custom-title" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(doctorName.value), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("p", _hoisted_2, _toDisplayString(doctorSpecialty.value), 1),
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_v_hover, null, {
                                  default: _withCtx(({ isHovering, props }) => [
                                    _createVNode(_component_v_card_subtitle, _mergeProps({
                                      class: "mt-2",
                                      onClick: openDocLocation
                                    }, props, { style: {"cursor":"pointer"} }), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          icon: "mdi-map-marker",
                                          color: isHovering ? 'primary' : ''
                                        }, null, 8, ["color"]),
                                        _createTextVNode(" " + _toDisplayString(doctorAddress.value), 1)
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_btn, {
                                  disabled: !doctor.value.linkedInLink,
                                  class: "ml-5",
                                  icon: "mdi-web",
                                  size: "small",
                                  color: "#3fb984",
                                  onClick: toDoctorLink
                                }, null, 8, ["disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_4, [
                                (doctor.value.universityLogo)
                                  ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_img, {
                                          width: "60",
                                          style: {"border-radius":"10%"},
                                          src: doctor.value.universityLogo
                                        }, {
                                          placeholder: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_5, [
                                              _createVNode(_component_v_progress_circular, {
                                                color: "grey-lighten-4",
                                                indeterminate: ""
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["src"]),
                                        _createTextVNode(_toDisplayString(doctor.value.university), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(SubscribeComponent, {
                                  photo: doctor.value.photo,
                                  name: `${doctor.value.title} ${doctor.value.lastName}`,
                                  onSubscribed: _cache[0] || (_cache[0] = ($event: any) => (subscribed($event)))
                                }, null, 8, ["photo", "name"])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                width: "150",
                                style: {"border-radius":"50%"},
                                src: doctor.value.photo ?? require('../../assets/profile_def.png')
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list, {
                        lines: "one",
                        class: "mt-5",
                        align: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "mdi-star" })
                                ]),
                                _: 1
                              })
                            ]),
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("doctor.famulatur")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(doctor.value.selectReason), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list, {
                        lines: "one",
                        align: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "mdi-clipboard-list" })
                                ]),
                                _: 1
                              })
                            ]),
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("doctor.requirement")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(doctor.value.requirementsForStudent), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list, {
                        lines: "one",
                        align: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "mdi-currency-eur" })
                                ]),
                                _: 1
                              })
                            ]),
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("doctor.financial-help")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(doctor.value.financialDescription), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list, {
                        lines: "one",
                        align: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "mdi-home-city" })
                                ]),
                                _: 1
                              })
                            ]),
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("doctor.area")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(doctor.value.areaDescription), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "large",
                            color: "#3fb984",
                            disabled: doctor.value.applied,
                            onClick: apply
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("apply")), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (!smallWindow.value)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    cols: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(StudentComment)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(FooterComponent)
  ], 64))
}
}

})